

import * as leaflet from "leaflet";
window.L = leaflet;

import omnivore from "leaflet-omnivore/index.js";
window.omnivore = omnivore;

// import "leaflet.smoothmarkerbouncing"	// Not needed since the use of Gleo bouncified sprites